import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import BudgetForm from '../../components/Budgets/BudgetForm';

const BudgetCreate = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <Link
          to="/app/budgets"
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <FiArrowLeft className="mr-2" />
          Back to Budgets
        </Link>
        <h1 className="text-3xl font-bold text-gray-900">Create New Budget</h1>
        <p className="text-gray-600 mt-1">Set up a new budget for a project</p>
      </div>

      <BudgetForm />
    </div>
  );
};

export default BudgetCreate;

